import {Directive, ElementRef, inject, Input, OnInit} from "@angular/core";
import {SecuritiesService} from "@kwsoft/otcx-core";
import {catchError, map, take} from "rxjs/operators";

@Directive({
    selector: "[otcxIsinToName]",
    standalone: false
})
export class IsinToNameDirective implements OnInit {

    @Input() isin: string;
    private readonly securitiesService = inject(SecuritiesService);
    private readonly element = inject(ElementRef<HTMLElement>);

    ngOnInit(): void {
        this.securitiesService.getSecurity(this.isin)
            .pipe(
                take(1),
                map(security =>
                    this.element.nativeElement.innerText = security.name
                ),
                catchError(() =>
                    this.element.nativeElement.style.display = "none"
                )).subscribe();
    }
}
